"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.redactProperties = exports.facebookIntegration = void 0;
const get_1 = __importDefault(require("lodash/get"));
const set_1 = __importDefault(require("lodash/set"));
// To reduce the noise on Facebook, we only send these conversion events
const facebookEventWhitelist = [
    "Onboarding::user.signup",
    "Onboarding::organization.created",
    "Onboarding::asset.1stCreated",
    "Onboarding::message.1stCreated",
    "Onboarding::user.1stInvited",
    "Onboarding::workOrder.1stCreated",
    "Onboarding::workOrder.5thCreated",
];
function facebookIntegration(eventName) {
    const enabled = eventName && facebookEventWhitelist.includes(eventName) ? true : false;
    return {
        "Facebook Pixel": enabled,
        "Facebook Conversions API (Actions)": enabled,
    };
}
exports.facebookIntegration = facebookIntegration;
const defaultPIIFieldsToRedact = [
    "email",
    "credential",
    "token",
    "phone",
    "address",
    "city",
    "state",
    "zip",
    "ip",
];
/**
 * Redact PII fields from properties
 */
function redactProperties(properties, additionalPIIFieldsToRedact) {
    if (!properties) {
        return properties;
    }
    // Copy properties to avoid mutating the original object
    const securedProperties = { ...properties };
    [...defaultPIIFieldsToRedact, ...(additionalPIIFieldsToRedact || [])].forEach((key) => {
        if ((0, get_1.default)(securedProperties, key)) {
            (0, set_1.default)(securedProperties, key, "REDACTED");
        }
    });
    return securedProperties;
}
exports.redactProperties = redactProperties;
//# sourceMappingURL=analyticsHelper.js.map